// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/CoreWebVitals/CoreWebVitals.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/CoreWebVitals/CoreWebVitals.tsx");
  import.meta.hot.lastModified = "1717182690459.8284";
}
// REMIX HMR END

import React from "react";
import Histogram from "./Histogram";
const CoreWebVitals = ({
  pass,
  lcp,
  cls,
  inp
}) => {
  const coreWebVitalItems = {
    lcp: {
      title: "Largest Contentful Paint",
      abbreviation: "LCP",
      description: "measures loading performance. To provide a good user experience, LCP must occur within 2.5 seconds of when the page first starts loading.",
      link: "https://web.dev/articles/lcp",
      value: lcp,
      segments: [69, 86, 100]
    },
    cls: {
      title: "Cumulative Layout Shift",
      abbreviation: "CLS",
      description: "measures visual stability. To provide a good user experience, must maintain a CLS of 0.1. or less.",
      link: "https://web.dev/articles/cls",
      value: cls,
      segments: [95, 98, 100]
    },
    inp: {
      title: "Interaction to Next Paint",
      abbreviation: "INP",
      description: "measures overall responsiveness to user interactions. To provide a good user experience, must be below or at 200 milliseconds.",
      link: "https://web.dev/articles/inp",
      value: inp,
      segments: [58, 81, 100]
    }
  };
  return <div className="flex gap-12 mb-4">
      <Histogram caption="core vitals" segments={pass ? [100, 0, 0] : [0, 0, 100]} pass={pass} />
      {Object.values(coreWebVitalItems).map(item => <Histogram key={item.title} caption={item.abbreviation} showP75 value={item.value} segments={item.segments} />)}
    </div>;
};
_c = CoreWebVitals;
export default CoreWebVitals;
var _c;
$RefreshReg$(_c, "CoreWebVitals");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;